var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 29C33 31.209 31.209 33 29 33H5C2.791 33 1 31.209 1 29V5C1 2.791 2.791 1 5 1H29C31.209 1 33 2.791 33 5V29Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1769 15.777L5.40295 12.256C5.29995 12.203 5.17695 12.207 5.07795 12.268C4.97895 12.329 4.91895 12.434 4.91895 12.551V14.701C4.91895 14.824 4.98795 14.937 5.09795 14.994L8.96195 17.004L5.09795 19.012C4.98895 19.069 4.91895 19.182 4.91895 19.307V21.45C4.91895 21.565 4.97995 21.673 5.07795 21.733C5.13095 21.764 5.19095 21.782 5.24995 21.782C5.30295 21.782 5.35495 21.768 5.40295 21.743L12.1769 18.223C12.2879 18.164 12.3569 18.051 12.3569 17.928V16.073C12.3559 15.947 12.2879 15.834 12.1769 15.777Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5407 15.777L13.7667 12.256C13.6627 12.203 13.5397 12.207 13.4407 12.268C13.3417 12.329 13.2827 12.434 13.2827 12.551V14.701C13.2827 14.824 13.3507 14.937 13.4607 14.994L17.3257 17.004L13.4607 19.012C13.3517 19.069 13.2827 19.182 13.2827 19.307V21.45C13.2827 21.565 13.3427 21.673 13.4407 21.733C13.4937 21.764 13.5537 21.782 13.6137 21.782C13.6657 21.782 13.7177 21.768 13.7667 21.743L20.5407 18.223C20.6507 18.164 20.7197 18.051 20.7197 17.928V16.073C20.7197 15.947 20.6507 15.834 20.5407 15.777Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.903 15.777L22.128 12.256C22.025 12.203 21.901 12.207 21.804 12.268C21.704 12.329 21.644 12.434 21.644 12.551V14.701C21.644 14.824 21.712 14.937 21.824 14.994L25.687 17.004L21.824 19.012C21.713 19.069 21.644 19.182 21.644 19.307V21.45C21.644 21.565 21.705 21.673 21.804 21.733C21.857 21.764 21.915 21.782 21.976 21.782C22.028 21.782 22.08 21.768 22.128 21.743L28.903 18.223C29.012 18.164 29.081 18.051 29.081 17.928V16.073C29.081 15.947 29.013 15.834 28.903 15.777Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.459b33f9de907226e65d8c98d1de8bb7.svg";
export { ForwardRef as ReactComponent };